import React from 'react';
import {
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Box,
    TextField,
    Typography,

} from '@mui/material';
 
const LocationDialog = (props) => {
    const onClick = (value) => {

        if (value === "cancel") {
            props.onCancelClick(false);
        }
        else if (value === "ok") {
            props.handleCnfClick();
        }
    }
   
    return (
        <div>
            <Dialog id="LocationDialogs"
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
            > 
                <DialogTitle id="alert-dialog-title">
                <Typography
                    variant="h4"
                    flexGrow={1}
                    fontSize={30}
                    fontWeight={700}
                    fontFamily={'Action NBA'}
                    noWrap
                    fontStyle="normal"
                    color='primary'
                    component="div"
                    sx={{
                        ml: 0,
                        pt: 2,
                        pb: 1,
                    }}
                >Add Location   </Typography>
                </DialogTitle>

                <DialogContent>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            flex: 0.5,
                            alignItems: 'center',
                            padding: 1,
                            width: 500
                        }}>
                        <TextField
                            size="small"
                            id="outlined-required"
                            label="Activity Location"
                            autoComplete="off"
                            // onBlur={validateEventName}
                            value={props.activityLocation}
                            onChange={(event) => {
                                props.activityLocationChange(event.target.value)
                            }}
                            onBlur={(event) => {
                                props.activityLocationChange(event.target.value)
                            }}
                            fullWidth
                        error={
                            props.activityLocationErr.length > 0 ? true : false
                        }
                        helperText={props.activityLocationErr}
                        inputProps={{ maxLength: 50 }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => onClick("cancel")} color="primary" variant="outlined" >
                        {props.CancelButtonText}
                    </Button>
                    <Button onClick={() => onClick("ok")} color="primary" variant="contained" autoFocus>
                        {props.OkButtonText}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default LocationDialog;

LocationDialog.defaultProps = {
    CancelButtonText: "Cancel",
    OkButtonText: "OK",
    title: '',
    message: ''
}